export function currentDate(){
  const date = new Date()
  const month = String(date.getMonth() + 1).padStart(2,0)
  const year = String(date.getFullYear()).slice(-2);
  const value = `${month}/${year}`;

  return {label: value, value};
}